/**
 * Guidance panel copy. The taxonomy itself lives in `src/taxonomy`.
 *
 * @module components/ui/guidance-examples
 */

/** Good and poor learning outcome examples. */
export const LO_EXAMPLES: { good: string; poor: string; issue: string }[] = [
  {
    good: "Analyse competing psychological theories of motivation and justify which best explains workplace behaviour.",
    poor: "Understand the theories of motivation.",
    issue: '"Understand" is not observable or measurable.',
  },
  {
    good: "Design a relational database schema that satisfies third normal form for a given business scenario.",
    poor: "Be familiar with database design.",
    issue: '"Be familiar with" does not specify what the learner will do.',
  },
  {
    good: "Evaluate the ethical implications of AI-driven decision-making in healthcare, citing relevant regulatory frameworks.",
    poor: "Know about AI ethics.",
    issue: '"Know about" is vague and does not indicate cognitive depth.',
  },
];
